const Filter = {
  filtering: false,

  init() {
    this.events();
  },

  events() {
    $("body").on("change", "#filters input", () => {
      this.handleFilter();
    });

    $("body").on("change", "select[name=order]", () => {
      this.handleFilter();
    });

    $("body").on("click", ".remove-filter", (e) => {
      const taxId = $(e.currentTarget).data("id");
      this.removeFilter(taxId);
    });

    $("body").on("click", ".clear-filters", () => {
      this.clearFilters();
    });

    // Pagination
    $("body").on("click", ".page-numbers:not(.prev):not(.next)", (e) => {
      e.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $("#catalog").offset().top - 100,
        },
        300
      );

      const cpage = parseInt($(e.currentTarget).text());
      this.handleFilter(cpage);
    });

    // Next
    $("body").on("click", ".next.page-numbers", (e) => {
      e.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $("#catalog").offset().top - 100,
        },
        300
      );

      const cpage = parseInt($(".page-numbers.current").text()) + 1;
      this.handleFilter(cpage);
    });

    // Prev
    $("body").on("click", ".prev.page-numbers", (e) => {
      e.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $("#catalog").offset().top - 100,
        },
        300
      );

      const cpage = parseInt($(".page-numbers.current").text()) - 1;
      this.handleFilter(cpage);
    });
  },

  removeFilter(taxId) {
    $(`[data-filter-group=${taxId}] input`).each(function () {
      if ($(this).is(":checked")) {
        $(this).prop("checked", false);
      }
    });
    $(`[data-filter-group=${taxId}] input`).trigger("change");
  },

  clearFilters() {
    $("[data-filter-group]").each(function () {
      const $filterGroup = $(this);
      const $inputs = $filterGroup.find("input");

      $inputs.each(function () {
        if ($(this).is(":checked")) {
          $(this).prop("checked", false);
        }
      });
    });

    this.handleFilter();
  },

  activeFilters() {
    const activeFilters = [];

    $("[data-filter-group]").each(function () {
      const $filterGroup = $(this);
      const $inputs = $filterGroup.find("input");

      let values = [];

      $inputs.each(function () {
        if ($(this).is(":checked")) {
          values.push($(this).val());
        }
      });

      if (values.length) {
        activeFilters.push({
          tax: $filterGroup.data("filter-group"),
          terms: values,
        });
      }
    });

    // Order
    const orderBy = $("select[name=order]").val();
    if (orderBy) {
      activeFilters.push({
        tax: "order",
        terms: [orderBy],
      });
    }

    return activeFilters;
  },

  handleFilter(cpage = 1) {
    if (this.filtering) {
      return;
    }
    this.filtering = true;

    const loaderEl = $("#loader");
    loaderEl.removeClass("hidden");

    const taxId = $("#catalog").data("id");

    const activeFilters = this.activeFilters();

    // Add each filter to url
    const url = new URL(window.location.origin + window.location.pathname);
    activeFilters.map((filter) => {
      filter.tax = filter.tax.replace("pa_", "");
      filter.terms = filter.terms.join(",");
      return filter;
    });
    activeFilters.forEach((filter) => {
      url.searchParams.append(filter.tax, filter.terms);
    });

    // add page
    url.searchParams.append("cpage", cpage);

    // Update url
    window.history.pushState({}, "", url);

    // Load new data
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "filter_products",
        cpage,
        tax_id: taxId,
        filters: activeFilters,
      },
    })
      .done((response) => {
        // console.log(response);
        $("#filtered").html(response.filtered);
        $("#filters").html(response.filters);
        $("#products").html(response.products);
        $("#pager").html(response.pager);
        $("#prod-count").html(response.count);
      })
      .always(() => {
        this.filtering = false;

        loaderEl.addClass("fade");
        setTimeout(function () {
          loaderEl.addClass("hidden").removeClass("fade");
        }, 500);
      });
  },
};

export default Filter;
